var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _vm.puedeCrear
              ? _c(
                  "button",
                  {
                    staticClass: "btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.crear }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _c("span", [_vm._v("Nuevo")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.exportarExcel }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-2" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("div", { staticClass: "form-inline__title" }, [
                  _vm._v("\n              Fecha\n            ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-inline__content" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipoFecha,
                          expression: "form.tipoFecha"
                        }
                      ],
                      attrs: { type: "radio", value: "H" },
                      domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "tipoFecha", "H")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Hoy")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipoFecha,
                          expression: "form.tipoFecha"
                        }
                      ],
                      attrs: { type: "radio", value: "A" },
                      domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "tipoFecha", "A")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Ayer")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipoFecha,
                          expression: "form.tipoFecha"
                        }
                      ],
                      attrs: { type: "radio", value: "P" },
                      domProps: { checked: _vm._q(_vm.form.tipoFecha, "P") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "tipoFecha", "P")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Personalizado")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipoFecha == "P",
                          expression: "form.tipoFecha == 'P'"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("VueCtkDateTimePicker", {
                            attrs: {
                              id: "desde",
                              locale: "es",
                              "only-date": "",
                              "no-label": "",
                              noClearButton: "",
                              "button-now-translation": "Ahora",
                              format: "YYYY-MM-DD",
                              formatted: "YYYY-MM-DD",
                              label: "Seleccione fecha..."
                            },
                            model: {
                              value: _vm.form.fechaDesde,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fechaDesde", $$v)
                              },
                              expression: "form.fechaDesde"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Desde:")])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipoFecha == "P",
                          expression: "form.tipoFecha == 'P'"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("VueCtkDateTimePicker", {
                            attrs: {
                              id: "hasta",
                              locale: "es",
                              "only-date": "",
                              "no-label": "",
                              noClearButton: "",
                              "button-now-translation": "Ahora",
                              format: "YYYY-MM-DD",
                              formatted: "YYYY-MM-DD",
                              label: "Seleccione fecha..."
                            },
                            model: {
                              value: _vm.form.fechaHasta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fechaHasta", $$v)
                              },
                              expression: "form.fechaHasta"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Hasta:")])
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("div", { staticClass: "form-inline__title" }, [
                  _vm._v("Estado")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-inline__content" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado,
                          expression: "form.estado"
                        }
                      ],
                      attrs: { type: "radio", value: "A" },
                      domProps: { checked: _vm._q(_vm.form.estado, "A") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado", "A")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Pendientes")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado,
                          expression: "form.estado"
                        }
                      ],
                      attrs: { type: "radio", value: "I" },
                      domProps: { checked: _vm._q(_vm.form.estado, "I") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado", "I")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Inactivos")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado,
                          expression: "form.estado"
                        }
                      ],
                      attrs: { type: "radio", value: "P" },
                      domProps: { checked: _vm._q(_vm.form.estado, "P") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado", "P")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Pagados")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado,
                          expression: "form.estado"
                        }
                      ],
                      attrs: { type: "radio", value: "T" },
                      domProps: { checked: _vm._q(_vm.form.estado, "T") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado", "T")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Todos")])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "multiselect-field" },
                  [
                    _c("multiselect", {
                      attrs: {
                        "preserve-search": "",
                        placeholder: "Busque y seleccione...",
                        selectedLabel: "Seleccionado",
                        selectLabel: "Presiona enter para seleccionar",
                        deselectLabel: "Presiona enter para eliminar",
                        label: "descripcion",
                        "track-by": "descripcion",
                        multiple: "",
                        options: _vm.rutas
                      },
                      on: {
                        "search-change": _vm.onSearchRutas,
                        input: _vm.inputRutas
                      },
                      model: {
                        value: _vm.selectedRutas,
                        callback: function($$v) {
                          _vm.selectedRutas = $$v
                        },
                        expression: "selectedRutas"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "rutas" } }, [_vm._v("Rutas")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        id: "cliente",
                        placeholder: "Seleccione...",
                        options: _vm.clientes,
                        label: "descripcion"
                      },
                      on: {
                        search: _vm.onSearchClientes,
                        input: _vm.inputCliente
                      },
                      model: {
                        value: _vm.selectedCliente,
                        callback: function($$v) {
                          _vm.selectedCliente = $$v
                        },
                        expression: "selectedCliente"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "cliente" } }, [
                      _vm._v("Cliente")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.periodo,
                          expression: "form.periodo"
                        }
                      ],
                      attrs: { name: "periodo", id: "periodo" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "periodo",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v("Seleccione...")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "D" } }, [
                        _vm._v("Diario")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "S" } }, [
                        _vm._v("Semanal")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "M" } }, [
                        _vm._v("Mensual")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "periodo" } }, [
                    _vm._v("Período")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        id: "buscar",
                        placeholder: "Realice una consulta..."
                      },
                      model: {
                        value: _vm.form.searchP,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "searchP", $$v)
                        },
                        expression: "form.searchP"
                      }
                    },
                    [_vm._v("\n              Consultar\n            ")]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12" },
          [
            _c("k-table", {
              ref: "listaPrestamos",
              attrs: {
                createButton: false,
                deleteButton: _vm.puedeAnular,
                editButton: _vm.puedeEditar,
                buttons: [
                  {
                    title: "Imprimir Estado de Cuenta",
                    icon: "fa fa-file-pdf-o",
                    class: "btn-success",
                    event: "imprimirEstadoCuenta"
                  }
                ],
                path: _vm.path,
                params: _vm.form,
                buscarButton: false,
                columns: [
                  {
                    display: "Cliente",
                    value: "cliente.descripcion_cliente"
                  },
                  {
                    display: "Ruta",
                    value: "ruta.nombre"
                  },
                  {
                    display: "Fecha desembolso",
                    value: "fecha_desembolso"
                  },
                  {
                    display: "Período",
                    value: "descripcion_periodo"
                  },
                  {
                    display: "Valor",
                    value: "valor",
                    numeric: true,
                    prefijo: "$"
                  },
                  {
                    display: "% Interés",
                    value: "porc_interes"
                  },
                  {
                    display: "Crédito",
                    value: "numero_documento"
                  },
                  {
                    display: "Cuotas",
                    value: "cuotas"
                  },
                  {
                    display: "CC",
                    value: "cuotas_canceladas"
                  },
                  {
                    display: "CF",
                    value: "cuotas_faltantes"
                  },
                  {
                    display: "PD",
                    value: "pagos_dominicales"
                  },
                  {
                    display: "AT",
                    value: "atrasos"
                  },
                  {
                    display: "Saldo",
                    value: "saldo",
                    numeric: true,
                    prefijo: "$"
                  },
                  {
                    display: "Total pagado",
                    value: "total_pagado",
                    numeric: true,
                    prefijo: "$"
                  },
                  {
                    display: "Estado",
                    value: "descripcion_estado"
                  },
                  {
                    display: "Creador",
                    value: "creador.nombre"
                  },
                  {
                    display: "Creación",
                    value: "created_at"
                  }
                ]
              },
              on: {
                editar: _vm.editar,
                eliminar: _vm.eliminarPrestamo,
                imprimirEstadoCuenta: _vm.imprimirEstadoCuenta
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "prestamo",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "65%",
            clickToClose: false
          }
        },
        [
          _c("prestamo", {
            attrs: {
              porcInteres: _vm.parametros ? _vm.parametros.porc_interes : 6,
              cuotas: _vm.parametros ? _vm.parametros.cuotas : 0,
              puedeCambiarInteres: _vm.puedeCambiarInteres,
              prestamoId: _vm.prestamoId
            },
            on: {
              guardar: function($event) {
                _vm.$modal.hide("prestamo")
                _vm.consultar()
              },
              cerrar: function($event) {
                return _vm.$modal.hide("prestamo")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Préstamos")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0554e9fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0554e9fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/ListaPrestamos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0554e9fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/ListaPrestamos.vue
// module chunks = 0